module.exports = __webpack_public_path__ + "static/media/badge-04-grey.cce70e96.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/badge/badge-04-grey.svg
// module id = 238
// module chunks = 0